import {
    FoodsPagination,
    FoodsPaginationItem,
    FoodsTooltip,
    PaginationPage,
    useFormBaseContext,
} from "@foodpilot/foods";
import { Stack } from "@mui/material";
import { useResponsiveBreakpoints } from "src/utils/useResponsiveBreakpoints";
import { QuestionnaireUpdatePage } from "../../layouts/QuestionnaireUpdateFormWithPages";
import { Link, useParams } from "react-router";
import { useTranslation } from "react-i18next";
import { useQuestionnaireFormContext } from "src/components/QuestionnaireForm/context/useQuestionnaireForm";

type Props = {
    pages: QuestionnaireUpdatePage[];
};
export const CenterPagination = (props: Props) => {
    const { t } = useTranslation();
    const { getHeadingUrl, post } = useQuestionnaireFormContext();
    const { headingId } = useParams();
    const { isExtraSmall, isMobile, isDesktop, isUltrawide } = useResponsiveBreakpoints();
    const { setPage, textOptions, onValidate } = useFormBaseContext();

    const { pages } = props;

    const completions = post?.completions;
    const pagination: PaginationPage[] = pages.map((page) => {
        const completion = completions?.headings?.[page.id]?.result;

        const renderedPage: PaginationPage = {
            label: page.title,
            isComplete: completion === 100,
            // isComplete: false,
            isCompleteLabel: t("questionnaire.heading.completed", "Completed"),
        };
        return renderedPage;
    });
    const startingPageIndex = pages.findIndex((i) => i.id === Number(headingId));
    return (
        <Stack
            // Hack for responsive, in order for the Pagination not to shrink too much
            minWidth={"275px"}
            alignItems={"center"}
        >
            <FoodsPagination
                page={startingPageIndex + 1}
                pages={pagination}
                renderItem={(params, currentPage) => {
                    if (params.page === null) {
                        return <FoodsPaginationItem {...params} currentPage={currentPage} />;
                    }

                    const isBelowMin = params.page === 0;
                    const isAboveMax = params.page > pages.length;
                    const isCurrentlySelected = params.selected;
                    if (isBelowMin || isAboveMax || isCurrentlySelected) {
                        const shouldFinishNext = isAboveMax;
                        if (shouldFinishNext) {
                            return (
                                <FoodsTooltip title={textOptions.finalPage}>
                                    <FoodsPaginationItem
                                        {...params}
                                        onClick={() => {
                                            onValidate?.();
                                        }}
                                        disabled={shouldFinishNext ? false : undefined}
                                        currentPage={currentPage}
                                    />
                                </FoodsTooltip>
                            );
                        }
                        return <FoodsPaginationItem {...params} currentPage={currentPage} />;
                    }

                    const p = pages[params.page - 1];
                    return (
                        <Link
                            to={getHeadingUrl(p.id)}
                            onClick={() => {
                                if (params.page === null) {
                                    return;
                                }
                                setPage(params.page - 1);
                            }}
                        >
                            <FoodsPaginationItem {...params} currentPage={currentPage} />
                        </Link>
                    );
                }}
                PaginationProps={{
                    siblingCount:
                        isUltrawide ? 2
                        : isDesktop ? 1
                        : isExtraSmall ? 0
                        : isMobile ? 2
                        : 0,
                }}
            />
        </Stack>
    );
};
